import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "../http/http.service";
import { Item, RentalReservation } from "./rental";


@Injectable()
export class RentalService {
  private url = '/api/rentals'

  constructor(private httpService: HttpService) {
  }

  getItems(location: string, group: string, date: string): Observable<Item[]> {
    return this.httpService.get(`${this.url}/items?location=${location}&group=${group}&date=${date}`)
      .map(res => res.json() as Item[]);
  }

  getReservations(location: string, group: string, date: string): Observable<RentalReservation[]> {
    return this.httpService.get(`${this.url}/reservations/${date}?location=${location}&group=${group}`)
      .map(res => res.json() as RentalReservation[]);
  }

  getRentalsDate(location: string, date: string): Observable<RentalReservation[]> {
    return this.httpService.get(`${this.url}/rentals/${date}?location=${location}`)
      .map(res => res.json() as RentalReservation[]);
  }

  getMyReservations(location: string, group: string): Observable<RentalReservation[]> {
    return this.httpService.get(`${this.url}/reservations/my?location=${location}&group=${group}`)
      .map(res => res.json() as RentalReservation[]);
  }

  reserve(rental: RentalReservation): Observable<RentalReservation> {
    return this.httpService.post(this.url, rental)
      .map(res => res.json() as RentalReservation);
  }

  cancel(id: number): Observable<RentalReservation> {
    return this.httpService.delete(`${this.url}/${id}`)
      .map(res => res.json() as RentalReservation);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/rental/rental.service.ts